// extracted by mini-css-extract-plugin
export default {"container":"ProvisionTestAccount_container__HHc3O App_paper__8CPy4"};